var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10.5,
    viewBox: "0 0 12 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,9.94c0,.31-.25,.56-.56,.56h-1.69c-1.24,0-2.25-1.01-2.25-2.25V2.25C0,1.01,1.01,0,2.25,0h1.69c.31,0,.56,.25,.56,.56s-.25,.56-.56,.56h-1.69c-.62,0-1.12,.51-1.12,1.12v6c0,.62,.51,1.12,1.12,1.12h1.69c.31,0,.56,.25,.56,.56Zm7.35-5.07l-2.98-3.19c-.21-.23-.57-.24-.79-.02-.23,.21-.24,.57-.02,.79l2.08,2.24H4.29c-.29,0-.54,.25-.54,.56s.25,.56,.54,.56h5.82l-2.11,2.24c-.21,.23-.2,.58,.02,.79,.13,.1,.27,.15,.39,.15,.15,0,.3-.06,.41-.18l2.98-3.19c.25-.22,.25-.55,.04-.77Z",
    fill: "#231f20"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/sign out.3f94f075.svg";
export { ForwardRef as ReactComponent };